// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import { ImageModel } from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonIcon, ButtonProps } from "@insite/mobius/Button";
// import Clickable from "@insite/mobius/Clickable"; // Starter Custom Code
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import ChevronUp from "@insite/mobius/Icons/ChevronUp";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import { injectCss } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { useEmblaCarousel } from "embla-carousel/react";
// import React, { useEffect, useState } from "react"; // Starter Custom Code
import { connect } from "react-redux";
import styled, { css } from "styled-components";

/* Starter Custom Code - Start */
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Carousel, { CarouselPresentationProps } from "@store/Overrides/Components/Carousel";
import { imageStyles } from "@store/Themes/common/mixins/image";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { BreakpointValueProp } from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { focusStyles, spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { useEffect, useState } from "react";

const imageWidth = pxToRem(70);
const imageSpacing = pxToRem(12);
const defaultNumberOfVisibleThumbnails = [3, 4, 4, 5];

export const productImageCarouselImageWidth = imageWidth;
/* Starter Custom Code - End */

// Foundation --->
// import constants from "@store/constants"; // Majestic
import useCanScroll from "@store/Framework/Store/Bunzl/Pages/ProductDetails/Hooks/useCanScroll";
import { DotButton } from "@store/Themes/common/props/dotButton";
import Hidden from "@insite/mobius/Hidden";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
// <--- Foundation

// Majestic --->
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import constants from "@store/constants";
// <--- Majestic

interface OwnProps {
    scrollingBehavior?: string;
    numberOfVisibleThumbnails?: BreakpointValueProp<number>; // Starter Custom Code
    selectedIndex?: number;
    onSelectImage?: (index: number) => void;
    extendedStyles?: ProductImageCarouselStyles;
}

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
});

type Props = OwnProps & HasProductContext & ReturnType<typeof mapStateToProps>;

export interface ProductImageCarouselStyles {
    mainContainer?: GridContainerProps;
    prevArrowGridItem?: GridItemProps;
    prevArrowButton?: ButtonProps;
    carouselGridItem?: GridItemProps;
    carouselWrapper?: InjectableCss;
    carouselContainer?: InjectableCss;
    /** @deprecated Use CarouselSlideContainer object instead. */
    carouselSlidesContainer?: InjectableCss;
    /** @deprecated Use CarouselSlide object instead. */
    carouselSlide?: InjectableCss;
    carouselSlideInner?: InjectableCss;
    image?: LazyImageProps;
    selectedImage?: LazyImageProps;
    nextArrowGridItem?: GridItemProps;
    nextArrowButton?: ButtonProps;
    verticalPrevArrowGridItem?: GridItemProps;
    verticalCarouselGridItem?: GridItemProps;
    verticalNextArrowGridItem?: GridItemProps;
    // Starter Custom Code
    mainWrapper?: InjectableCss;
    innerWrapper?: InjectableCss;
    carousel?: CarouselPresentationProps;
    clickable?: ClickablePresentationProps;
    // Foundation
    placeholder?: InjectableCss;
    dotsWrapper?: InjectableCss;
    hiddenDotsWrapper?: InjectableCss;
}

const carouselImageSize = pxToRem(80); // Majestic

const getImageCss = (borderColor: string) => css`
    width: auto; /* Majestic */
    height: 100%;
    max-width: ${carouselImageSize};
    max-height: ${carouselImageSize};
    border: ${pxToRem(2)} solid ${getColor(borderColor)};
    cursor: pointer;
    justify-content: center;
    img {
        max-width: ${carouselImageSize};
        max-height: ${carouselImageSize};
        padding: ${pxToRem(3)};
    }
`;

export const productImageCarouselStyles: ProductImageCarouselStyles = {
    mainContainer: { gap: 0 },
    prevArrowGridItem: {
        width: 1,
        align: "middle",
        css: css`
            justify-content: flex-end;
        `,
    },
    prevArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            border: 0;
            padding: 0;
        `,
    },
    carouselGridItem: { width: 10 },
    carouselWrapper: {
        css: css`
            width: 100%;
        `,
    },
    carouselContainer: {
        css: css`
            display: flex;
            overflow: hidden;
            min-width: ${pxToRem(90)};
            max-height: 32em;
            padding-right: ${pxToRem(10)};
            margin-right: ${pxToRem(20)};
        `,
    },
    carouselSlidesContainer: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    carouselSlide: {
        css: css`
            flex: 0 0 ${100 / 6}%;
            padding: 0;
            position: relative;
        `,
    },
    carouselSlideInner: {
        css: css`
            width: 100%;
            text-align: center;
            position: relative;
            ${contentSpacingStyles(0, 0, "1em")}
        `,
    },
    image: {
        css: getImageCss("common.background"),
    },
    selectedImage: {
        css: getImageCss("primary"),
    },
    nextArrowGridItem: {
        width: 1,
        align: "middle",
        css: css`
            justify-content: flex-start;
        `,
    },
    nextArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            border: 0;
            padding: 0;
        `,
    },
    dotsWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            width: 100%;
        `,
    },
    hiddenDotsWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            width: 100%;
            margin-top: ${pxToRem(10)};
        `,
    },
    placeholder: {
        css: css`
            width: ${pxToRem(80)};
            height: ${pxToRem(255)};
            margin-right: ${pxToRem(20)};
            background-color: ${getColor("common.accent")};

            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: none;
                        `,
                        null,
                        css`
                            display: block;
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
};

export const CarouselSlidesContainer = styled.div<
    InjectableCss & { isVertical: boolean; numberOfVisibleThumbnails: number }
>`
    display: flex;
    flex-direction: ${props => (props.isVertical ? "column" : "row")};
    align-items: ${props => (props.isVertical ? "center" : "initial")};
    ${props => (props.isVertical ? `height: ${props.numberOfVisibleThumbnails * 74}px;` : "")}
    ${injectCss};
`;

export const CarouselSlide = styled.div<InjectableCss & { numberOfVisibleThumbnails: number }>`
    flex: 0 0 ${props => 100 / props.numberOfVisibleThumbnails}%;
    padding: 0;
    position: relative;
    ${injectCss};
`;

const ProductImageCarousel = ({
    productSettings,
    productContext,
    scrollingBehavior,
    numberOfVisibleThumbnails = defaultNumberOfVisibleThumbnails, // Starter Custom Code
    selectedIndex,
    onSelectImage,
    extendedStyles,
}: Props) => {
    const [styles] = useState(() => mergeToNew(productImageCarouselStyles, extendedStyles));
    const { product } = productContext;
    const nbImagesMinForArrow = 2; // Starter Custom Code

    // Foundation --->
    const [emblaRef, embla] = useEmblaCarousel(); // Moved from below

    const productImages = product.images?.filter(
        i => !i.name.includes(constants.imageTypes.sizeChart) && !i.name.includes(constants.imageTypes.seriesBadges),
    );

    useEffect(() => {
        if (!embla) {
            return;
        }

        embla.on("init", setCanScroll);
        embla.on("select", setCanScroll);
    }, [embla]);

    const { canScrollNext, canScrollPrev, setCanScrollNext, setCanScrollPrev } = useCanScroll();
    // <--- Foundation

    const [selectedImageIndex, setSelectedImageIndex] = useState(0); // Foundation
    useEffect(() => {
        // Foundation --->
        if (typeof selectedIndex === "number") {
            setSelectedImageIndex(selectedIndex);
        }
        // <--- Foundation
    }, [selectedIndex, embla?.canScrollNext(), embla?.canScrollPrev()]); // Foundation

    const imageClickHandler = (index: number) => {
        setSelectedImageIndex(index);
        onSelectImage?.(index);
        // Foundation
        embla?.scrollTo(index);
        setCanScroll();
        // Foundation
    };

    // Foundation Removed Code + useEmblaCarousel moved to top

    const setCanScroll = () => {
        setCanScrollPrev(!!embla && embla.canScrollPrev());
        setCanScrollNext(!!embla && embla.canScrollNext());
    };

    // Foundation --->
    const [scrollSnaps, setScrollSnaps] = useState<number[]>();

    useEffect(() => {
        const handleScrollNext = () => {
            if (embla?.canScrollNext()) {
                const index = selectedImageIndex + 1;

                embla?.scrollNext();
                setCanScroll();
                setSelectedImageIndex(index);
                onSelectImage?.(index);
            }
        };

        const handleScrollPrev = () => {
            if (embla?.canScrollPrev()) {
                const index = selectedImageIndex - 1;

                embla?.scrollPrev();
                setCanScroll();
                setSelectedImageIndex(index);
                onSelectImage?.(index);
            }
        };

        document.addEventListener("click:primaryImageScrollNext", handleScrollNext);
        document.addEventListener("click:primaryImageScrollPrev", handleScrollPrev);

        return () => {
            document.removeEventListener("click:primaryImageScrollNext", handleScrollNext);
            document.removeEventListener("click:primaryImageScrollPrev", handleScrollPrev);
        };
    }, [embla, selectedImageIndex, canScrollNext, canScrollPrev]);
    // <--- Foundation

    useEffect(() => {
        if (!embla) {
            return;
        }

        embla.on("init", setCanScroll);
        embla.on("select", setCanScroll);
    }, [embla]);

    useEffect(() => {
        if (!embla || !product.images) {
            return;
        }

        // Foundation
        setScrollSnaps(embla.scrollSnapList());
        embla.reInit({
            align: "start",
            slidesToScroll: 1,
            axis: "y",
            // Foundation Custom Code
            draggable: false,
        });
        setCanScroll();
    }, [embla, product]);
    // Foundation Custom Code

    const getProductImageThumbPath = (productImage: ImageModel) => {
        if (productImage.imageType === "Static") {
            return productImage.smallImagePath || productImage.mediumImagePath;
        }
        if (productImage.imageType === "360" && productSettings.imageProvider === "SIRV") {
            return productImage.mediumImagePath + (productImage.mediumImagePath.indexOf("?") > 0 ? "&thumb" : "?thumb");
        }
        return "";
    };

    if (!product || !product.images || product.images?.length === 0) {
        return null;
    }

    /* Starter Custom Code - Change GridItem for StyledWrapper */
    return (
        /* Foundation Removed Code - Arrow Left */
        <>
            {/* Foundation ---> */}
            <Hidden above="xs" {...styles.hiddenDotsWrapper}>
                {scrollSnaps && (
                    <StyledWrapper {...styles.dotsWrapper}>
                        {scrollSnaps.map((scrollSnap, index) => {
                            return (
                                <DotButton
                                    key={scrollSnap}
                                    selected={index === selectedImageIndex}
                                    onClick={() => imageClickHandler(index)}
                                />
                            );
                        })}
                    </StyledWrapper>
                )}
            </Hidden>
            <Hidden below="sm">
                <StyledWrapper {...styles.carouselContainer} ref={emblaRef}>
                    <StyledWrapper {...styles.carouselSlidesContainer}>
                        {productImages?.map((productImage, index) => (
                            <StyledWrapper {...styles.carouselSlide} key={productImage.id}>
                                <StyledWrapper {...styles.carouselSlideInner}>
                                    <LazyImage
                                        {...(index === selectedImageIndex ? styles.selectedImage : styles.image)}
                                        src={getProductImageThumbPath(productImage)}
                                        altText={productImage.imageAltText}
                                        onClick={() => imageClickHandler(index)}
                                    />
                                </StyledWrapper>
                            </StyledWrapper>
                        ))}
                    </StyledWrapper>
                </StyledWrapper>
            </Hidden>{" "}
        </>
        /* Foundation Removed Code */
    );
};

export default connect(mapStateToProps)(withProductContext(ProductImageCarousel));
